; (function ($) {
	"use strict";
	jQuery(document).ready(function () {
		jQuery('.query-loop__filter-form select').on('change', function () {
			jQuery(this).parents('.query-loop__filter-form').trigger('submit')
		})
	});
})(jQuery);
